import moment from "moment";
import "./Exdialogstyle.scss";
import { useContext } from "react";
import DatePicker from "react-datepicker";
import AlertContext from "../../../../context/AlertContext";

export default function Extdialog(props) {
  const Alert = useContext(AlertContext);

  return (
    <div className="extDialogContainer">
      <div>
        <table>
          <tr>
            <td className="extdialog-details-row-label">Learner:</td>{" "}
            <td className="extdialog-details-row-value">
              {" "}
              &nbsp;{props.cellobj.lname}
            </td>
          </tr>
          <tr>
            <td className="extdialog-details-row-label">Test:</td>{" "}
            <td className="extdialog-details-row-value">
              {" "}
              {/* &nbsp;{props.cellobj.testname} */}
              &nbsp;{props.cellobj.tname}
            </td>
          </tr>
          <tr>
            <td className="extdialog-details-row-label">Test Due Date: </td>{" "}
            <td className="extdialog-details-row-value">
              {" "}
              &nbsp;
              {moment(props.cellobj.duedate).format("MMMM Do YYYY, h:mm a")}
            </td>
          </tr>
        </table>
      </div>
      <>
        <div className="extdialog-datepicker-div">
          <h6>New Deadline:&nbsp; </h6>
          <DatePicker
            showIcon
            showTimeInput
            timeInputLabel="Time:"
            minDate={moment().toDate()}
            className="codingDatePicker"
            dateFormat="dd/MMM/yyyy h:mm aa"
            selected={new Date(Alert.extensionDate)}
            onChange={(date) => {
              localStorage.setItem(
                "extensionDate",
                moment(date).format("YYYY-MM-DD HH:mm:ss")
              );
              Alert.setExtensionDate(
                moment(date).format("YYYY-MM-DD HH:mm:ss")
              );
            }}
          />
        </div>

        <div className="comments-score-section-score-reject-box-score-button-section-exdialog"></div>
      </>
    </div>
  );
}
